import React, { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';

import useApiMutation from '../../../Hooks/useApiMutation';
import Dialog from '../../DesignSystem/Dialog';
import ButtonWithLoader from '../../ButtonWithLoader';
import useSpace from '../../../Hooks/useSpace';
import queriesConfig from '../../../Services/queriesConfig';
import { editPostPath } from '../../../Utils/routes';
import { useNotifications } from '@toolpad/core/useNotifications';
import { notify } from '../../../Utils/NotificationUtils';

function CloneDialog({ postId, open, onClose }: any) {
  const intl = useIntl();
  const { space } = useSpace();
  const notifications = useNotifications();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const {
    mutate: clonePost,
    isLoading,
    isSuccess,
  } = useApiMutation({
    query: queriesConfig.clonePost(postId),
    onSuccess: (newPost) => {
      navigate(editPostPath(space.slug, newPost.slug, newPost.type));
      notify(notifications, intl.formatMessage({ id: 'POSTS.CLONE.CONTENT_CLONED' }));
      queryClient.invalidateQueries(['dashboar-posts']);
      onClose();
    },
  });

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess]);

  const handleClonePost = () => {
    clonePost();
  };

  const dialogTitle = intl.formatMessage({ id: 'POSTS.CLONE.ACTION' });
  const dialogActions = (
    <>
      <Button variant="outlined" size="large" onClick={onClose} color="primary">
        <FormattedMessage id="POSTS.CLONE.CANCEL" />
      </Button>
      <ButtonWithLoader
        isFetching={isLoading}
        variant="contained"
        size="large"
        onClick={handleClonePost}
        color="primary"
        disabled={isLoading}
      >
        <FormattedMessage id="POSTS.CLONE.CONFIRM" />
      </ButtonWithLoader>
    </>
  );

  return (
    <Dialog
      id={`delete-post-dialog-${postId}`}
      open={open}
      title={dialogTitle}
      label={dialogTitle}
      actions={dialogActions}
      onClose={onClose}
      variant="small"
    >
      <Typography variant="body1">
        <FormattedMessage id="POSTS.CLONE.DESCRIPTION" />
      </Typography>
    </Dialog>
  );
}

export default CloneDialog;
